export class TwoFaVerifyModel {
  TotpSecretkey: string;
  TotpVerifyCode: string;
}
